import React, { memo } from 'react';
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { IFilterDropdown } from '../../../AppState/overagesFilterFormActions';
import { S_GRID_PROPS } from "../../../constants";

interface PackageTypeSelectProps {
  disabled?: boolean;
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  options: IFilterDropdown[];
  error?: boolean;
  helperText?: string;
  required?: boolean;
  gridProps?: { md: number; xs: number };
}

// Constants
const SELECT_STYLE = {
  fontSize: '13px',
} as const;

// Custom icon component for dropdown
const CustomIconComponent = () => (
  <div className="dropdown-icon-group">
    <ArrowDropUpIcon className="icon-style" />
    <ArrowDropDownIcon className="icon-style" />
  </div>
);

const PackageTypeSelect: React.FC<PackageTypeSelectProps> = memo(({
  id = '',
  label,
  value,
  onChange,
  onBlur,
  options,
  error = false,
  helperText,
  required = false,
  gridProps = S_GRID_PROPS,
  disabled = false,
}) => {
  const handleChange = (event: any) => {
    onChange(event.target.value as string);
  };

  return (
    <Grid item {...gridProps}>
      <FormControl
        fullWidth
        size="small"
        error={error}
        disabled={disabled}
      >
        <InputLabel style={SELECT_STYLE} shrink={true} id={`${id}Label`} htmlFor={id}>
          {label} {required && <sup>*</sup>}
        </InputLabel>
        <Select
          variant="outlined"
          id={id}
          className="select"
          fullWidth
          onChange={handleChange}
          onBlur={onBlur}
          error={error}
          name={id}
          value={value || ''}
          style={SELECT_STYLE}
          displayEmpty
          labelId={`${id}Label`}
          renderValue={(selected) => {
            if (!selected) {
              return <em>Select {label}</em>;
            }
            return selected;
          }}
          IconComponent={CustomIconComponent}
        >
          {options.map((option: IFilterDropdown) => (
            <MenuItem
              style={SELECT_STYLE}
              key={option?.actualValue || option?.code}
              value={option?.actualValue}
            >
              {option?.actualValue}
            </MenuItem>
          ))}
        </Select>
        {error && helperText && (
          <FormHelperText>{helperText}</FormHelperText>
        )}
      </FormControl>
    </Grid>
  );
});

PackageTypeSelect.displayName = 'PackageTypeSelect';

export default PackageTypeSelect;